import { WebSocketSearchSourcesType } from "@/shared/service/wsSearch/types";

export type Loadings = {
  searchLoading: boolean;
  searchMNNLoading: boolean;
  restart: boolean;
  searchDataLoading: boolean;
  searchAutoLoading: boolean;
  searchSaveDataLoading: boolean;
  saveMnn: boolean;
  saveReportLoading: boolean;
};


export type SearchMNNNumber = {
  source: string;
  patentNum: string;
}; 

export type SelectedMNNType = {
  value: string;
  label: string;
};

export type SearchMNNType = {
  mnn_en: string;
  mnn_ru: string;
  synonyms_en: string[];
  session_synonyms_en?: string[];
};


export type GroupingTableType = {
  id: number;
  title: string;
  title_short: string;
  is_result_table: boolean;
};

export type GroupingTableByIdType = {
  document_id: number;
  selected_table_ids: number[];
  expire_date: string | null;
  national_phase_expire_date: string | null;
  expire_date_if_national: string | null;
};

export type DetailFormType = {
  formula: string;
  formula_comment: string;
  translated_formula: string;
  formula_comment_created_at: string | null;
  formula_comment_updated_at:string | null;
};

export type SaveReportTableDataType = {
  name: string;
  data: Record<string, string>;
  is_manual?: boolean;
};

export type SaveReportType = {
  idSession: number;
  mnn: string;
  title: string;
  firstParagraph: string;
  secondParagraph: string;
  summaryParagraph: string;
  summaryTable: {
    data: SaveReportTableDataType[];
    comment: string;
  };
  note: string;
};

export type NotesModalType = 
  {
    id: number;
    note_text: string;
    created_user_id: number;
    created_at: string;
    updated_at: string;
    user_fio: string;
  };

export type ActiveSessionsType = {
  id: number;
  combination_mnn: string;
  title: string;
  created_at: string;
  is_joined_compilation: boolean;
  is_finished: boolean;
  search_mode: string;
  is_copied?: boolean;
  is_updated?: boolean;
};

export enum StatusEnum  {
  'archived' = 'архивирована',
  'deleted' = 'удалена',
  'cancelled' = 'отменена',
  'finished' = 'отмена'
}

export type TemplateType = {
  id?: number;
  title:string | null;
  last_updated: string;
  saved_path: string;
};

export type JsonTemplateType = {
  template_text: string;
};


export type JsonReportDataType = {
  id_session: number;
  document_ids: number[];
  mnn: string;
  title: string;
  first_paragraph: string;
  second_paragraph: string;
  summary_paragraph: string;
  summary_table: {
    data: SaveReportTableDataType[];
    comment: string;
  };
  note: string;
};


export type ReportConclusionType = {
  title: string;
  mnns: string[];
  conclusion_documents: number[];
  json_path: string | null;
  jsonData?: JsonReportDataType | null;
};


export type SessionSourceStatusesType = {
  source_statuses: WebSocketSearchSourcesType;
  session_synonyms: string[];
};
